module.exports = __webpack_public_path__ + "img/山豆根.7e9ad773.jpg";